import { render, staticRenderFns } from "./productIndex.vue?vue&type=template&id=4d8b99ee&scoped=true&"
import script from "./productIndex.vue?vue&type=script&lang=js&"
export * from "./productIndex.vue?vue&type=script&lang=js&"
import style0 from "./productIndex.vue?vue&type=style&index=0&id=4d8b99ee&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8b99ee",
  null
  
)

export default component.exports